import { JourneyItem } from './TranscriptToolRow';

export const isHiddenJourneyItem = (item: JourneyItem) => item.extra?.hidden === 'true';

export const getVisibleJourneyItems = (items?: JourneyItem[]) =>
  items?.filter((item) => !isHiddenJourneyItem(item)) ?? [];
